import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import axios from "axios";
import B2bRegistration from "../b2b/b2bRegistraion/B2bRegistration";
import Meetings from "../b2b/collaborators/Meetings";
import Faqs from "./collaborators/Faqs";
import ParticipateCountry from "./collaborators/ParticipateCountry";
import EditB2bRegistration from "../b2b/b2bRegistraion/EditB2bRegistration";
import { getAuthUserlocal } from "../../../../store/services";
import { getURLbyEndPointV2 } from "../../../../store/api";


const CollaborationReqTrack = () => {
  const [activeTab, setActiveTab] = useState("Registration");
  const [showMore, setShowMore] = useState(false);
  const [registrationData, setRegistrationData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const userId = getAuthUserlocal()._id;

  useEffect(() => {
    if (activeTab === "Registration") {
      const fetchRegistrationData = async () => {
        try {
          const regData = await axios.get(
            getURLbyEndPointV2("getB2bRegistration") + userId
          );
          setRegistrationData(regData.data.data);
        } catch (error) {
          console.error("Error fetching registration data:", error);
          setRegistrationData(null); // Reset if no data or error
        }
      };
      fetchRegistrationData();
    }
  }, [activeTab, userId]);

  const handleReadMoreClick = (e) => {
    e.preventDefault();
    setShowMore(!showMore);
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCloseEdit = () => {
    setIsEditing(false);
  };

  const handleUpdate = async () => {
    try {
      const regData = await axios.get(getURLbyEndPointV2("getB2bRegistration") + userId);
      setRegistrationData(regData.data.data);
      // Do not setIsEditing(false) here to stay on Edit page
    } catch (error) {
      console.error("Error fetching updated registration data:", error);
    }
  };

  return (
    <div>
      <div className="pt-2 px-3 fw-semibold">
        <p>
          <span className="fw-bold">Virtual B2B Forum</span> is designed to strengthen business connections between foreign trade experts and Indian businesses, thus helping both sides to expand their reach globally.{" "}
          <span className="pb-2">
            {!showMore && (
              <a href="#!" onClick={handleReadMoreClick} style={{ cursor: "pointer", display: "inline-block" }}>
                Read more..
              </a>
            )}
          </span>
        </p>
      </div>
      <div className="px-3 fw-semibold">
        {showMore && (
          <div id="moreContent">
            <p>
              Through the B2B Forum our partners/Expert collaborators can have the opportunity to create meaningful international business connections. By getting access to our trade members they can have a wider international network and that too without making financial investment.
            </p>
            <p>
              Precisely, Virtual B2B Forum works as a bridge between the collaborators and Indian businesses and assists them in expanding their business.{" "}
              <a href="#!" onClick={handleReadMoreClick} style={{ cursor: "pointer", display: "inline-block" }}>
                Read less..
              </a>
            </p>
          </div>
        )}
      </div>
      <hr className="p-0 m-0" />
      <Nav
        variant="pills"
        activeKey={activeTab}
        onSelect={(selectedKey) => setActiveTab(selectedKey)}
        style={{ display: "flex", width: "100%" }}
      >
        {["FAQs", "Registration", "Participating countries", "Meetings"].map((tab) => (
          <Nav.Item key={tab} style={{ flex: 1, textAlign: "center" }}>
            <Nav.Link
              eventKey={tab}
              style={{
                width: "100%",
                fontWeight: "bold",
                borderRadius: 0,
                padding: "10px 0",
                backgroundColor: activeTab === tab ? "blue" : "#f4f4f9",
                color: activeTab === tab ? "white" : "black",
              }}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <hr className="p-0 m-0" />
      <div className="py-2 px-3 border mt-3">
        {activeTab === "FAQs" && <Faqs setActiveTab={setActiveTab} />}
        {activeTab === "Registration" &&
          (isEditing ? (
            <EditB2bRegistration
              registrationData={registrationData}
              onUpdate={handleUpdate}
              onClose={handleCloseEdit}
            />
          ) : (
            <B2bRegistration onEditClick={registrationData ? handleEditClick : null} />
          ))}
        {activeTab === "Participating countries" && <ParticipateCountry />}
        {activeTab === "Meetings" && <Meetings />}
      </div>
      <div className="py-2 px-3 border mt-3" style={{ fontSize: "0.9em" }}>
        <p className="fw-semibold text-danger">
          <span className="fw-bold">Note:</span> <br/> Before proceeding with this form, please take a moment to carefully read the{" "}
          <span className="text-decoration-underline cursor-pointer" onClick={() => setActiveTab("FAQs")}>
            FAQs.
          </span>{" "}
          Ensure that all relevant details are accurately filled in. Select your preferred time slots for the next three months so that business participants can request appointments accordingly. Meetings will be confirmed based on mutual convenience and availability.
        </p>
      </div>
    </div>
  );
};

export default CollaborationReqTrack;